var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33398 7.24992V0.833252H16.334V7.24992",
    stroke: "#767676",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.33366 15.5H3.50033C3.0141 15.5 2.54778 15.3068 2.20396 14.963C1.86015 14.6192 1.66699 14.1529 1.66699 13.6667V9.08333C1.66699 8.5971 1.86015 8.13079 2.20396 7.78697C2.54778 7.44315 3.0141 7.25 3.50033 7.25H18.167C18.6532 7.25 19.1195 7.44315 19.4634 7.78697C19.8072 8.13079 20.0003 8.5971 20.0003 9.08333V13.6667C20.0003 14.1529 19.8072 14.6192 19.4634 14.963C19.1195 15.3068 18.6532 15.5 18.167 15.5H16.3337",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.334 11.8333H5.33398V19.1666H16.334V11.8333Z",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintReport);
export default __webpack_public_path__ + "static/media/printReport.d594550c2a508d5d946dd19e93da799e.svg";
export { ForwardRef as ReactComponent };